<template>
  <v-container
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
  >
    <v-tabs
      v-model="tab"
      style="margin: 0 12px 0;"
    >
      <v-tab
        v-for="(n,i) in tabs"
        :key="i"
        :href="`#${n.id}`"
        @click="changeTab(n.id)"
      >
        {{ n.text }}
      </v-tab>
    </v-tabs>
    <v-flex xs12>
      <v-tabs-items 
        v-model="tab"
      >
        <v-tab-item
          :transition="false" 
          :reverse-transition="false"
          value="dashboard"
        >
          <aff-dashboard v-if="tab == 'dashboard'" />
        </v-tab-item>  
        <v-tab-item
          :transition="false" 
          :reverse-transition="false"
          value="refTable"
        >
          <referral-table v-if="tab == 'refTable'" />
        </v-tab-item> 
        <v-tab-item
          :transition="false" 
          :reverse-transition="false"
          value="tree"
        >
          <tree 
            v-if="tab == 'tree'" 
          />
        </v-tab-item>  
        <v-tab-item
          :transition="false" 
          :reverse-transition="false"
          value="transactions"
        >
          <transactions 
            v-if="tab == 'transactions'" 
          />
        </v-tab-item>  
        <v-tab-item
          :transition="false" 
          :reverse-transition="false"
          value="withdrawals"
        >
          <withdrawals 
            v-if="tab == 'withdrawals'" 
          />
        </v-tab-item>  
      </v-tabs-items>   
    </v-flex>
  </v-container>
</template>

<script>

import affDashboard from '@/views/Affiliates/partial/Dashboard.vue'
import tree from '@/views/Affiliates/partial/Tree.vue'
import transactions from '@/views/Affiliates/partial/Transactions.vue'
import withdrawals from '@/views/Affiliates/partial/Withdrawals.vue'
import referralTable from '@/views/Affiliates/partial/ReferralTable.vue'

export default {
  name: 'AffMain',
  components: {
    affDashboard,
    referralTable,
    tree,
    transactions,
    withdrawals
  },
  data() {
    return {
      tab: null,
      tabs: [ {id: "dashboard", text: this.$t('aff.dashboard')},
              {id: "refTable", text: this.$t('aff.refs')},
              {id: "tree", text: this.$t('aff.tree')},
              {id: "transactions", text: this.$t('aff.transactions')},
              {id: "withdrawals", text: this.$t('aff.withdrawals')}]
    }
  },
  mounted() {
    if (this.$route.params.id != undefined)
      this.tab = this.$route.params.id
  },
  methods: {
    changeTab(tab) {
      this.tab = tab
    }
  }
}
</script>
<style lang="scss" scoped>
.v-tabs-items {
    background-color: transparent;
}
</style>
